import React from 'react'
import 'assets/scss/detail2.scss'
import { boolStr } from 'helpers/utils'
import { formatDateTime } from 'common/usual'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'

export default function({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Audio URL</TableCell>
            <TableCell>Duration</TableCell>
            <TableCell>Language ID</TableCell>
            <TableCell>Country ID</TableCell>
            <TableCell>Active</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map(audio => (
            <TableRow key={audio.id}>
              <TableCell>{audio.id}</TableCell>
              <TableCell>
                <a href={audio.audio_url} target="_blank" rel="noopener noreferrer">
                  {audio.audio_url}
                </a>
              </TableCell>
              <TableCell>{audio.duration}s</TableCell>
              <TableCell>{audio.locale_language?.code}</TableCell>
              <TableCell>{audio.locale_country?.code}</TableCell>
              <TableCell>{boolStr(audio.active)}</TableCell>
              <TableCell>{formatDateTime(audio.created_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
    
}
